module.exports = __webpack_public_path__ + "img/logo.6339f724.png";